import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'

import { ChatPanel } from '../../chat/chat-panel'
import { userService } from '../../../services'

export default function EmployeeChatSection() {
  const { t } = useTranslation()
  const { id } = useParams()

  const { data: user } = useQuery({
    queryKey: ['user', id],
    queryFn: () => userService.getUserById(id!),
    enabled: !!id,
  })

  if (!id) return null

  const fullName = user ? `${user.firstName} ${user.lastName}` : ''

  return (
    <div className='space-y-4'>
      <div>
        <h2 className='text-lg font-semibold text-neutral-900'>{t('chat.title')}</h2>
        <p className='text-sm text-neutral-500 mt-0.5'>{t('chat.employeeSubtitle')}</p>
      </div>
      <ChatPanel employeeUserId={id} employeeName={fullName} className='min-h-[560px]' />
    </div>
  )
}
